import React, { useEffect, useState, useContext } from "react";

import PropTypes from "prop-types";
import AppContext from "context/Context";
import Flex from "components/common/Flex";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, Col, Modal, Row, Button, Image } from "react-bootstrap";
import IconButton from "components/common/IconButton";
import * as Constants from "common/constants";
import * as General from "common/general";
import Loader from "components/custom/Loader";
import { useTranslation } from "react-i18next";

const DeleteGeneratorConfirmation = ({ company, showComponent, hideDeleteConfirmation, successCallBackFunction, selectedGenerator }) => {
	const [errorContainerVisiblity, showErrorContainer] = useState(false);
	const [loaderContainerVisibility, showLoaderContainer] = useState(false);
	const [buttonsVisibility, showHideButtons] = useState(true);
	const [RelatedCompanytypeIcon, setRelatedCompanytypeIcon] = useState("");

	const [t, i18n] = useTranslation();

	const handleCancelDelete = () => {
		hideDeleteConfirmation();
	};

	const handleConfirmDelete = async () => {
		showLoaderContainer(true);
		showHideButtons(false);
		showErrorContainer(false);
		const DeleteselectedGeneratorSuccess = (responseObject) => {
			handleCancelDelete();
			successCallBackFunction(true);
			showLoaderContainer(false);
			showHideButtons(true);
		};

		const DeleteselectedGeneratorFailure = (error) => {
			showErrorContainer(true);
			setTimeout(function () {
				var errorContainer = document.getElementById("errorContainer");
				if (errorContainer.innerHTML == "") {
					errorContainer.innerHTML = "An error occured, please try again later. " + error;
				}
				showLoaderContainer(false);
				showHideButtons(true);
			}, 1000);
		};

		var deleteEndpoint = Constants.DeleteTransporterGeneratorData + selectedGenerator.id;
		try {
			await General.DeleteFromEndPoint(deleteEndpoint, null, null, DeleteselectedGeneratorSuccess, DeleteselectedGeneratorFailure);
		} catch (error) {
			DeleteselectedGeneratorFailure(error);
		}
	};

	const {
		config: { isRTL },
	} = useContext(AppContext);

	return (
		<Modal show={showComponent} onHide={handleCancelDelete} size="lg">
			<Modal.Header closeButton className="border-200">
				<Modal.Title as="h5">
					<Flex alignItems="center">
						<div className="icon-item bg-soft-success shadow-none">
							<FontAwesomeIcon icon={RelatedCompanytypeIcon} className="text-success" />
						</div>
						<div className="ms-2">{t(`Remove Related Generator`)}</div>
					</Flex>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Row className="g-0 align-items-center">
					<Col>
						<div className="mb-3">
							{t(`Are you sure you want to remove this related Generator?`)}
							<br /> <br />
							{t(`Generator Company ID`)}: <strong>{selectedGenerator.generetorCompanyId}</strong>
							<br />
							{t("Generated Waste Type")}: <strong>{selectedGenerator.generatedWasteType}</strong>
							<br />
							{t(`Company Type`)}: <strong>{selectedGenerator.wasteType}</strong>
							<br />
							{t("Unified National Number")}: <strong>{selectedGenerator.unn}</strong>
							<br />
							{t(`CR Number`)}: <strong>{selectedGenerator.crNumber}</strong>
							<br />
							{t("Address")}: <strong>{selectedGenerator.address}</strong>
							<br />
							{t(`Facility Name`)}: <strong>{selectedGenerator.companyName}</strong>
							<br />
							{t("Phone Number")}: <strong>{selectedGenerator.phoneNumber}</strong>
							<br />
						</div>
					</Col>
				</Row>
			</Modal.Body>
			<Modal.Footer className="border-200">
				{buttonsVisibility && (
					<div>
						<Button onClick={handleCancelDelete} size="sm" variant="secondary">
							{t("No")}
						</Button>
						<IconButton onClick={handleConfirmDelete} icon="check" size="sm" className="ms-2" variant="danger">
							{t("Yes")}
						</IconButton>
					</div>
				)}

				{loaderContainerVisibility && <Loader></Loader>}

				{errorContainerVisiblity && <div id="errorContainer" className="loginAlert popupAlert"></div>}
			</Modal.Footer>
		</Modal>
	);
};

DeleteGeneratorConfirmation.propTypes = {
	company: PropTypes.object,
	showComponent: PropTypes.bool,
};

export default DeleteGeneratorConfirmation;
